import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/auth.guard';
import { ShellComponent } from './layout/shell.component';

export const routes: Routes = [
  { path: 'sign-in', canActivate: [guestGuard], loadComponent: () => import('./features/sign-in.component').then((m) => m.SignInComponent) },
  { path: 'c/:token', loadComponent: () => import('./features/acuse.component').then((m) => m.AcuseComponent) },
  {
    path: '',
    canActivate: [authGuard],
    component: ShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
      { path: 'inicio', loadComponent: () => import('./features/home.component').then((m) => m.HomeComponent) },
      { path: 'socios', loadComponent: () => import('./features/members.component').then((m) => m.MembersComponent) },
      { path: 'censos', loadComponent: () => import('./features/census.component').then((m) => m.CensusComponent) },
      { path: 'cuotas', loadComponent: () => import('./features/quotas.component').then((m) => m.QuotasComponent) },
      { path: 'estado-cuenta', loadComponent: () => import('./features/billing.component').then((m) => m.BillingComponent) },
      { path: 'bafi/turno', loadComponent: () => import('./features/shift.component').then((m) => m.ShiftComponent) },
      { path: 'bafi/folios', loadComponent: () => import('./features/folios.component').then((m) => m.FoliosComponent) },
      { path: 'mantenimiento', loadComponent: () => import('./features/maintenance.component').then((m) => m.MaintenanceComponent) },
      { path: 'pozos', loadComponent: () => import('./features/wells.component').then((m) => m.WellsComponent) },
      { path: 'avisos', loadComponent: () => import('./features/notices.component').then((m) => m.NoticesComponent) },
      { path: 'administracion', loadComponent: () => import('./features/admin.component').then((m) => m.AdminComponent) },
    ],
  },
  { path: '**', redirectTo: 'inicio' },
];
